import {useQuery} from "@tanstack/react-query"
import {useInjection} from "../../contexts/InversifyContext"
import MenuApiType, {IMenuApi} from "../../interfaces/IMenuApi"
import QueryKeys from "./QueryKeys"

export function useGetMenu(customerId: string) {
	const menuApi = useInjection<IMenuApi>(MenuApiType.IMenuApi)
	return useQuery({
		queryKey: QueryKeys.detail(customerId),
		queryFn: () => menuApi.getMenuByCustomer(customerId),
		enabled: !!customerId && menuApi != null,
		staleTime: 60 * 60 * 1000
	})
}